import {
  stopWaitingForReadyNotificationFromRocket,
  waitForReadyNofificationFromRocket,
} from './readyNotification';

type Listener = () => void;

let ready = false;
let waiting = false;
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((listener) => listener());
}

function setReady(next: boolean) {
  if (ready === next) return;
  ready = next;
  emit();
}

export function subscribeRocketReady(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getRocketReadySnapshot() {
  return ready;
}

/** Start listening for Rocket's ready notification if not already ready/waiting. */
export function beginWaitingForRocketReady() {
  if (ready || waiting) return;

  waiting = true;
  void waitForReadyNofificationFromRocket()
    .then(() => {
      waiting = false;
      setReady(true);
    })
    .catch(() => {
      waiting = false;
    });
}

/** Clear ready state and cancel any in-flight ready wait (e.g. iframe unmounted). */
export function resetRocketReady() {
  waiting = false;
  stopWaitingForReadyNotificationFromRocket();
  setReady(false);
}
